import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage, Translate } from '../../core';
import { IControlProps, MapProps } from '.';
import { InputText, SelectButton } from '../prime';
import styles from './multilang.module.scss';
import Common from '../../services/common';
import { MultiLangDto } from '../../model';

interface IProps extends IControlProps<MultiLangDto> {
  storage?: IDataStorage;
}

interface IState extends IControlProps<MultiLangDto> {
  storage?: IDataStorage;
  /** Indica el mensaje de error si es que existe */
  validError?: string;

  lang?: number;
  values?: MultiLangDto;
}

class Index extends React.Component<IProps, IState> {
  state : IState = { };
  key: string = `Input-${Common.object.uuidv4()}`;

  componentDidMount = () => {

    Index.getDerivedStateFromProps(this.props, this.state);
    if (this.props?.form && this.props?.name) this.props.form.add(this, this.props.name, () => { return undefined; /* pendiente de ver como validamos */});
    this.setState({ lang: Translate.languages.find(p => p.code === this.state.storage?.languaje)?.id ?? 1 })
  }
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    const getText = (lang:string, key:string) => {
      const real = Translate.get('API.Diccionario', lang)(key as string);
      if (real.startsWith('@') && real.includes('#')) return '';
      return real;
    }
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.value !== s?.value && !!p.value) {
      if (typeof p.value === 'string') {
        const values : { lang:string; text:string; }[] = [];
        Translate.languages.forEach(lang => {
          values.push({
            lang: lang.code,
            text: getText(lang.code, p.value as string)
          });
        })

        res.values = { key: '@', values }
      } else if (typeof p.value === 'object') {
        res.values = p.value;
      }
    }
    return MapProps(res, p, s);
  }

  change = (text:string) => {
    let { values, required } = this.state;

    console.log("cambiandoooo", text, values)
    if (!values) {
      values = {
        key: "@",
        values: []
      }
    }

    const obj = this.state.values?.values?.find(p => p.idIdioma === this.state.lang);
    if (obj) {
      obj.text = text;
      obj.updated = true;
    } else if (!!values) {
      if (!values.values) values.values = [];
      values.values.push({ idIdioma: this.state.lang, text: text, updated: true });
    }
    
    let error : string | undefined = undefined;
    if (required && values?.values?.find(p => !p.text || p.text === ''))
      error = 'campo requerido en todos los idiomas';

    this.setState({ value: values, values, validError: error }, () => this.props.onChange && this.props.onChange(values, error));
  }

  render() {
    const { validError } = this.state;
    const value = this.state.values?.values?.find(p => p.idIdioma === this.state.lang);

    return (
      <div className={`form-group ${this.state.className ?? ''}`} style={this.state.style}>
        {this.state.title && <label className={(validError && styles.errortitle) ?? ''}>{this.state.title}</label>}
        <div className={`${styles.addons} p-inputgroup ${styles.container}`}>
          {this.state.required && 
            <span className={`p-inputgroup-addon ${(validError && styles.erroraddon) ?? ''}`}>
              <i className="pi pi-exclamation-circle" />
            </span>
          }          
          <InputText 
            id={this.key}
            value={value?.text}
            placeholder={this.state.placeholder}
            readOnly={this.state.disabled}
            tooltip={validError}
            tooltipOptions={{ position: 'bottom' }}
            className={`${styles.ctrl} ${validError && 'p-error'}`}
            onChange={e => !this.state.disabled && this.change(e.target.value)}
          />
          <SelectButton 
            optionLabel="code" optionValue="id" 
            multiple={false} 
            value={this.state.lang} options={Translate.languages} 
            onChange={e => !!e.value && this.setState({ lang: e.value }, () => {
              const value = this.state.values?.values?.find(p => p.idIdioma === e.value);
              $(`#${this.key}`).val(value?.text ?? '').focus().select();
            })}
          />
        </div>
        {validError && <span className={styles.errordesc}>{validError}</span>}
      </div>
    );
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
